import { Injectable } from '@angular/core';
import {
    EntityCollectionServiceBase,
    EntityCollectionServiceElementsFactory,
} from 'ngrx-data';
import { Observable } from 'rxjs';
import { LoginService } from 'src/app/login/services/login-service.service';

import { ObjectStore } from './object-store.dto';
import { tap, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ObjectStoreService extends EntityCollectionServiceBase<
    ObjectStore
> {
    constructor(
        serviceElementsFactory: EntityCollectionServiceElementsFactory,
        private loginServce: LoginService
    ) {
        super('ObjectStore', serviceElementsFactory);

        loginServce.loggedIn$.subscribe(v => {
            this.clearCache();
            this.getAll();
        });

        loginServce.loggedOut$.subscribe(v => {
            this.clearCache();
        });

        this.getAll(); // IF user refresh page while still logged in
    }

    getAll(): Observable<ObjectStore[]> {
        return super.getAll();
    }
}
